import { initEnv } from 'shared/env'
import './boot.css'

// Flag to track reload attempts
const HAS_RELOADED_KEY = 'env_initialization_reload_attempted'

// Initialize environment before rendering the app
async function bootstrap() {
  try {
    // Initialize environment
    await initEnv()

    // Only import main.tsx after environment is initialized
    await import('./main')

    // Clear the reload flag if successful
    sessionStorage.removeItem(HAS_RELOADED_KEY)
  } catch (error) {
    console.error('Failed to initialize environment:', error)

    // Check if we've already tried reloading
    const hasReloaded = true

    if (hasReloaded) {
      // Already attempted reload, show error instead
      const mutableRootElement = document.querySelector('#root')!
      mutableRootElement.innerHTML = `
        <div class="boot-error">
          <div class="boot-error__card">
            <h1 class="boot-error__title">Later Influence Failed to Start</h1>
            <p class="boot-error__text">There was an error initializing the application. Please try again later or contact support.</p>
            <button
              class="boot-error__btn"
              onclick="sessionStorage.removeItem('${HAS_RELOADED_KEY}'); window.location.reload();"
            >Try Again</button>
          </div>
        </div>
      `
      globalThis.hideLoader?.()
    } else {
      // Mark that we've attempted a reload
      sessionStorage.setItem(HAS_RELOADED_KEY, 'true')

      // Attempt reload
      globalThis.location.reload()
    }
  }
}

bootstrap()
